import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Mail, Phone, Building2, ArrowRight } from 'lucide-react';
import { contactMock } from '../data/mock';

const FORMS_URL = "https://forms.gle/n5o3Ld3dCXix5Nqd7";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main>
        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight mb-6">
              Kontakt
            </h1>
            <p className="text-xl text-slate-500 leading-relaxed">
              Máte zájem o školení nebo chcete vědět víc? Vyplňte krátký formulář
              a ozveme se vám do 24 hodin.
            </p>
          </div>
        </section>

        {/* Google Forms CTA */}
        <section className="py-12 bg-gradient-to-br from-teal-600 to-cyan-600">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-teal-100 text-sm font-semibold tracking-widest uppercase mb-4">
              Nezávazná poptávka
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
              Nezávazně poptat školení
            </h2>
            <p className="text-teal-100 text-lg mb-10 leading-relaxed">
              Formulář zabere 2 minuty. Ozveme se vám do 24 hodin.
            </p>
            <a
              href={FORMS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white hover:bg-teal-50 text-teal-700 font-bold rounded-xl text-xl transition-all shadow-xl shadow-teal-700/20 group"
            >
              Otevřít formulář
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-teal-200 text-sm mt-6">Financovatelné z OP JAK II</p>
          </div>
        </section>

        {/* Přímý kontakt */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-8">
              Nebo nás kontaktujte přímo
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              <a
                href={`mailto:${contactMock.email}`}
                className="flex items-center gap-4 p-5 bg-white rounded-xl border border-slate-200 hover:border-teal-300 hover:bg-teal-50 transition-all group"
              >
                <div className="w-11 h-11 rounded-lg bg-teal-100 flex items-center justify-center flex-shrink-0 group-hover:bg-teal-200 transition-colors">
                  <Mail className="w-5 h-5 text-teal-600" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-0.5">E-mail</p>
                  <p className="font-semibold text-teal-600">{contactMock.email}</p>
                </div>
              </a>

              <div className="flex flex-col gap-3">
                {contactMock.phones.map((phone, i) => (
                  <a
                    key={i}
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    className="flex items-center gap-4 p-4 bg-white rounded-xl border border-slate-200 hover:border-teal-300 hover:bg-teal-50 transition-all group"
                  >
                    <div className="w-11 h-11 rounded-lg bg-teal-100 flex items-center justify-center flex-shrink-0 group-hover:bg-teal-200 transition-colors">
                      <Phone className="w-5 h-5 text-teal-600" />
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-0.5">Telefon</p>
                      <p className="font-semibold text-teal-600">{phone}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Fakturační údaje */}
            <div className="bg-white rounded-xl border border-slate-200 p-6">
              <div className="flex items-start gap-3">
                <Building2 className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Fakturační údaje</p>
                  <p className="font-bold text-slate-900">UniqueCreative s.r.o.</p>
                  <p className="text-slate-500 text-sm italic mb-2">Součást skupiny vzdělávací agentury GAVITO technic s.r.o.</p>
                  <p className="text-slate-600 text-sm">IČO: 19876815</p>
                  <p className="text-slate-600 text-sm">Rybná 716/24, Staré Město, 110 00 Praha</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
